import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ToastProvider } from './components/ToastProvider'
import CombinedPage from './pages/CombinedPage'
import Admin from './pages/Admin'
import Security from './pages/Security'
import Employees from './pages/Employees'
import EmployeeLogin from './pages/EmployeeLogin'
import EmployeeDashboard from './pages/EmployeeDashboard'

function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route path="/" element={<CombinedPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/security" element={<Security />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/employee-login" element={<EmployeeLogin />} />
          <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
        </Routes>
      </Router>
    </ToastProvider>
  )
}

export default App
